import React from 'react';
import styles from './Footer.module.css';
import { Link, useLocation } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa6';
import { motion } from 'framer-motion';
import logoImg from '../../assets/logo.png';
import { useSelector } from 'react-redux';
import { getTranslation } from '../../util/utilFunc';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { language } = useSelector(state => state.auth);
  const location = useLocation();

  // console.log(location.pathname);

  return (
    <section >
      <footer>
        <motion.div
          initial={{ opacity: 0, transform: "translateX(-100px)" }}
          whileInView={{ opacity: 1, transform: "translateX(0)" }}
          transition={{ delay: 0.2 }}
          className={styles.footer__item}
        >
          <div className={styles.logo__item}>
            <img src={logoImg} alt="Compelion Logo" />
            <h3>Compelion</h3>
          </div>
          <p>
            {getTranslation("At Compelion, we do more than manage ideas—we bring them to life. Powered by AI, precise analytics, and world-class methodologies, we turn bold visions into actionable strategies. Every idea is guided toward measurable success, delivering real results and lasting impact. Where ideas take flight and strategy soars, Compelion is your partner in driving innovation, growth, and strategic excellence", language)}
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, transform: "translateY(100px)" }}
          whileInView={{ opacity: 1, transform: "translateY(0)" }}
          transition={{ delay: 0.3 }}
          className={styles.footer__link__wrapper}
        >
          <h4>{getTranslation("COMPANY", language)}</h4>
          <Link to="/">{getTranslation("Home", language)}</Link>
          <Link to="/about-us">{getTranslation("About", language)}</Link>
          <Link to="/contact-us">{getTranslation("Contact", language)}</Link>
          <Link to="/pricing">{getTranslation("Pricing", language)}</Link>
          {location.pathname !== "/contact-us" && <a href="#ourServices">{getTranslation("Our Services", language)}</a>}
        </motion.div>
        <motion.div
          initial={{ opacity: 0, transform: "translateY(100px)" }}
          whileInView={{ opacity: 1, transform: "translateY(0)" }}
          transition={{ delay: 0.4 }}
          className={styles.footer__link__wrapper}
        >
          <h4>{getTranslation("HELP", language)}</h4>
          <Link to="/">{getTranslation("Customer Support", language)}</Link>
          <Link to="/terms-and-conditions">{getTranslation("Terms & Conditions", language)}</Link>
          <Link to="/privacy-policy">{getTranslation("Privacy Policy", language)}</Link>
          <Link to="/security">{getTranslation("Security", language)}</Link>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, transform: "translateX(100px)" }}
          whileInView={{ opacity: 1, transform: "translateX(0)" }}
          transition={{ delay: 0.5 }}
          className={styles.social__links}
        >
          <h4>{getTranslation("Connect with Us", language)}</h4>
          <a href="/">
            <FaTwitter className={styles.social__icon} />
          </a>
          <a href="/">
            <FaFacebookF className={styles.social__icon} />
          </a>
          <a href="/">
            <FaInstagram className={styles.social__icon} />
          </a>
          <a href="/">
            <FaYoutube className={styles.social__icon} />
          </a>
        </motion.div>
      </footer>
      <motion.small
        initial={{ opacity: 0, transform: "translateY(100px)" }}
        whileInView={{ opacity: 1, transform: "translateY(0)" }}
        transition={{ delay: 0.6 }}
        className={styles.copyrightText}
      >
        {getTranslation("© Copyright", language)} {currentYear}, {getTranslation("All Rights Reserved by Compelion", language)}
      </motion.small>
    </section>
  )
}
export default Footer;